import { render, staticRenderFns } from "./CombinationsConfiguratorTemplate.vue?vue&type=template&id=566e62e6&scoped=true"
import script from "./CombinationsConfiguratorTemplate.vue?vue&type=script&setup=true&lang=ts"
export * from "./CombinationsConfiguratorTemplate.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CombinationsConfiguratorTemplate.vue?vue&type=style&index=0&id=566e62e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566e62e6",
  null
  
)

export default component.exports